import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <div className="auth">
      <div className="auth-container">
        <div className="login-logo">
          <h1>Wallet UI</h1>
        </div>
        <div className="login-title">Logging out...</div>
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default Logout;
